<template>
  <ul class="category">
    <li v-for="category in categories" :key="category.id">
      <button class="button-product" @click="selectedCategory=category;modalShow = true;">
        <div class="badge">{{category.figure_count}}タイプ</div>
        <div v-html="category.svg"></div>
        <div class="label" v-html="category.name"></div>
      </button>
      <div :show.sync="modalShow" :class="{'uk-modal':true,'uk-open':modalShow}" v-if="selectedCategory === category">
        <div class="uk-modal-dialog">
          <button class="uk-close uk-icon uk-modal-close-default" @click="modalShow = false">
            <svg width="14" height="14" viewBox="0 0 14 14"><path fill="none" stroke="#000" stroke-width="1.1" d="M1 1l12 12M13 1L1 13"></path></svg>
          </button>
          <div class="uk-modal-body">
            <div class="uk-modal-header">
              <h2>{{ selectedCategory.name | stripTags }}</h2>
              ( {{ category.figure_count }}タイプ )
            </div>
            <div class="uk-modal-body">
              <div v-html="selectedCategory.svg"></div>
              <div v-html="selectedCategory.comment"></div>
            </div>
            <div slot="footer" class="uk-text-center">
              <div v-if="notSameCategory===true" class="warning">
                  ※他のアイテム、タイプ、デザインを選択されると、現在編集中のデザインはクリアされますのでご注意ください。
              </div>
              <vk-button class="close" @click="modalShow = false">キャンセル</vk-button>
              <vk-button class="close" @click="save">決定</vk-button>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
  import { mapActions } from 'vuex'
  import axios from 'axios/dist/axios.min'

  export default {
    name: 'category',
    data(){
      return {
        categories: [],
        modalShow: false,
        selectedCategory: {
          name:'',
          comment:'',
          svg:'',
        },
      }
    },
    computed: {
      notSameCategory() {
        if (this.$store.state.cart.category === null) return null;
        return this.selected_category.id !== this.$store.state.cart.category.id;
      }
    },
    methods: {
      ...mapActions(['selected_category']),
      save: function() {
        this.modalShow = false;
        this.selected_category(this.selectedCategory);
        if (this.notSameCategory === true) {
          this.$store.commit('clearFigure');
          this.$store.commit('clearDesign');
          this.$store.commit('clearLetters');
          this.$store.commit('clearPacks');
          this.$store.commit('disableAfterActiveTab', 0);
        }
        this.$router.push({name:'product-figure', params: {category_id: this.selectedCategory.id}});
      }
    },
    created(){
      this.$store.commit('setLoading');
      axios.get('categories.json')
        .then(response => {
          for (let i = 0; i < response.data.categories.length; i++) {
            this.categories.push(response.data.categories[i]);
          }
          this.$store.commit('resetLoading');
        });
    },
    deactivated(){
      this.$store.commit('resetLoading');
    },
  }
</script>

<style lang="scss" scoped>
  .warning {
    text-align: left;
    color: #ee0000;
    font-size: 90%;
    margin-bottom: 1em;
  }
  button {
    height: 100px;
    padding: 0;
    .label {
      position: absolute;
      top: 26px;
      width: 110px;
      line-height: 0.9rem;
    }
    .badge {
      border-radius: 0;
      bottom: 0;
      top: auto;
      width: 100%;
      right: auto;
    }
  }
</style>
